import { defineMessages } from 'react-intl';

export const apiErrorMessages = defineMessages({
  suspect: {
    id: 'api-error.suspect',
    defaultMessage:
      'Your promotion cannot be activated because you’ve previously had an active ClassPass account. <a href="/pricing">See Plans</a> or <a href="/contact">Contact Us</a> for help.',
    hasHtml: true,
  },
  billingError: {
    id: 'api-error.billing-error',
    defaultMessage: 'There was a problem processing your request. Please provide a valid payment method to continue.',
  },
  genericMessage: {
    id: 'api-error.generic-message',
    defaultMessage:
      'Uh oh! Something unexpected occurred. We were not able to process your request. Please <a target="_blank" rel="noopener noreferrer" href="/contact">reach out to us</a> and we’ll help you keep moving.',
    hasHtml: true,
  },
  incorrectPassword: {
    id: 'api-error.incorrectPassword',
    defaultMessage: 'Your current password is incorrect.',
  },
});

export const userErrorMessages = defineMessages({
  genericMessage: {
    id: 'Errors.UserError.genericMessage',
    defaultMessage: 'Oops! Something went wrong. Please refresh the page or try again later.',
  },
});
